package pl.mothdigital.neuronowi.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initTermsAndConditionsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("TermsAndConditions.md", FrontMatterElement.EmptyMap))
}

@Page("/terms-and-conditions")
@Composable
fun TermsAndConditionsPage() {
    pl.mothdigital.neuronowi.components.layouts.MarkdownLayout("Regulamin organizacyjny", "Niepublicznej Poradni Psychologiczno-Pedagogicznej „Centrum Terapii NeuroNowi” Sp. z o.o.") {
        org.jetbrains.compose.web.dom.H1(attrs = { id("regulamin-organizacyjny") }) {
            org.jetbrains.compose.web.dom.Text("REGULAMIN ORGANIZACYJNY")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Niepublicznej Poradni Psychologiczno-Pedagogicznej „Centrum Terapii NeuroNowi” Sp. z o.o. ul. Fabryczna 17a/1, 65-410 Zielona Góra")
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("1-postanowienia-ogólne") }) {
            org.jetbrains.compose.web.dom.Text("§1. Postanowienia ogólne")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Niniejszy regulamin określa organizację i zasady funkcjonowania Niepublicznej Poradni Psychologiczno-Pedagogicznej „Centrum Terapii NeuroNowi” Sp. z o.o., zwanej dalej „Poradnią”.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Poradnia działa na podstawie:")
                org.jetbrains.compose.web.dom.Ul {
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Ustawy Prawo oświatowe z dnia 14 grudnia 2016 r.;")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Ustawy o prawach pacjenta i Rzeczniku Praw Pacjenta;")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Rozporządzeń MEN i przepisów wykonawczych;")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Wpisu do ewidencji szkół i placówek niepublicznych;")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Statutu Poradni;")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Niniejszego regulaminu.")
                    }
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Organem prowadzącym Poradnię jest spółka z ograniczoną odpowiedzialnością „Centrum Terapii NeuroNowi” Sp. z o.o., reprezentowana przez wspólniczki: Magdalenę Nowik i Żaklinę Wykręt.")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("2-cele-i-zadania-poradni") }) {
            org.jetbrains.compose.web.dom.Text("§2. Cele i zadania Poradni")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Celem Poradni jest diagnozowanie, wspieranie rozwoju i prowadzenie terapii dzieci i młodzieży oraz wspomaganie rodziców i opiekunów prawnych.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Do zadań Poradni należy:")
                org.jetbrains.compose.web.dom.Ul {
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Prowadzenie diagnoz (psychologicznych, pedagogicznych, logopedycznych, SI);")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Realizacja terapii indywidualnej i grupowej (psychologicznej, pedagogicznej, logopedycznej, SI, ręki, terapii EEG Biofeedback, słuchowych, Neurotaktylnej MNRI, zajęcia TUS i innych);")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Organizowanie WWRD;")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Wydawanie opinii, zaświadczeń i (po uzyskaniu odpowiednich uprawnień) orzeczeń;")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Organizowanie konsultacji, szkoleń, warsztatów i działań profilaktycznych;")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Współpraca z instytucjami edukacyjnymi, społecznymi i zdrowotnymi.")
                    }
                }
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("3-organizacja-pracy-poradni") }) {
            org.jetbrains.compose.web.dom.Text("§3. Organizacja pracy Poradni")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Poradnia funkcjonuje przez cały rok kalendarzowy, z wyjątkiem dni ustawowo wolnych od pracy i okresów przerw ustalonych przez kierownictwo.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Godziny pracy są ustalane indywidualnie w harmonogramie zgodnym z potrzebami pacjentów i dostępnością specjalistów.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Zajęcia prowadzone są na podstawie umowy zawartej z rodzicem/opiekunem prawnym dziecka.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Na zajęciach terapeutycznych dziecku może towarzyszyć rodzic lub opiekun – zgodnie z ustaleniami zespołu prowadzącego.")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("4-zasady-uczestnictwa-w-zajęciach") }) {
            org.jetbrains.compose.web.dom.Text("§4. Zasady uczestnictwa w zajęciach")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Zgłoszenie dziecka do Poradni odbywa się na podstawie formularza rejestracyjnego i wywiadu wstępnego.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Obowiązują następujące zasady odwoływania zajęć:")
                org.jetbrains.compose.web.dom.Ul {
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Nieobecność dziecka należy zgłosić co najmniej 24 godziny przed zajęciami – wtedy możliwe jest ustalenie nowego terminu (w miarę dostępności).")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("W przypadku braku zgłoszenia, zajęcia przepadają i nie podlegają odpracowaniu.")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("Zajęcia odwołane przez Poradnię (np. z powodu nieobecności terapeuty) są odpracowywane w innym terminie.")
                    }
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Rodzice są zobowiązani do informowania Poradni o stanie zdrowia dziecka, szczególnie w przypadku chorób zakaźnych lub przeciwwskazań do udziału w terapii.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Poradnia nie ponosi odpowiedzialności za skutki zatajenia przez rodzica informacji o stanie zdrowia dziecka.")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("5-kadra-specjalistyczna") }) {
            org.jetbrains.compose.web.dom.Text("§5. Kadra specjalistyczna")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("W Poradni pracują wykwalifikowani specjaliści posiadający wymagane przepisami prawa kwalifikacje:")
                org.jetbrains.compose.web.dom.Ul {
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("psychologowie,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("pedagodzy,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("logopedzi,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("terapeuci SI,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("inni terapeuci i konsultanci (np. neurologopeda, terapeuta TUS).")
                    }
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Każdy pracownik posiada przydzielony zakres obowiązków i działa zgodnie z wewnętrznymi procedurami placówki.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Specjaliści podlegają nadzorowi pedagogicznemu oraz dbają o stałe podnoszenie swoich kwalifikacji.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Poradnia zobowiązuje się zapewnić wszystkie pomoce potrzebne do przeprowadzenia zajęć.")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("6-dokumentacja-i-poufność") }) {
            org.jetbrains.compose.web.dom.Text("§6. Dokumentacja i poufność")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Poradnia prowadzi dokumentację w formie papierowej i/lub elektronicznej:")
                org.jetbrains.compose.web.dom.Ul {
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("kartoteki pacjentów,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("dzienniki zajęć,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("rejestry opinii i zaświadczeń,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("harmonogramy pracy specjalistów,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("listy obecności i protokoły diagnoz.")
                    }
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Dane osobowe dzieci i rodziców są chronione zgodnie z przepisami RODO.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Pracownicy Poradni są zobowiązani do zachowania poufności w zakresie danych osobowych i informacji uzyskanych w trakcie pracy.")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("7-wydawanie-informacji") }) {
            org.jetbrains.compose.web.dom.Text("§7. Wydawanie informacji")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Poradnia może wydawać informacje:")
                org.jetbrains.compose.web.dom.Ul {
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("o postępach w terapii wczesnego wspomagania rozwoju,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("o potrzebach dostosowania wymagań edukacyjnych,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("o pomocy psychologiczno-pedagogicznej,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("o innej formie wsparcia – zgodnie z przepisami prawa,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("na prośbę rodzica.")
                    }
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Wydanie informacji następuje po przeprowadzeniu zajęć i obserwacji oraz analizy dokumentacji i sytuacji dziecka.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Informacja podpisywana jest przez specjalistów uczestniczących w diagnozie oraz osobę upoważnioną przez Poradnię.")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("8-skargi-i-reklamacje") }) {
            org.jetbrains.compose.web.dom.Text("§8. Skargi i reklamacje")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Skargi dotyczące pracy Poradni lub jej personelu mogą być składane:")
                org.jetbrains.compose.web.dom.Ul {
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("osobiście,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("pisemnie,")
                    }
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("drogą elektroniczną na adres e-mail Poradni: ")
                        com.varabyte.kobweb.silk.components.navigation.Link("mailto:neuronowizg@gmail.com") {
                            org.jetbrains.compose.web.dom.Text("neuronowizg@gmail.com")
                        }
                    }
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Skarga zostaje rozpatrzona przez dyrektora lub osobę przez niego wyznaczoną w terminie 14 dni.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Odpowiedź na skargę udzielana jest w tej samej formie, w jakiej została zgłoszona.")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("9-postanowienia-końcowe") }) {
            org.jetbrains.compose.web.dom.Text("§9. Postanowienia końcowe")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Regulamin wchodzi w życie z dniem zatwierdzenia przez osoby zarządzające spółką.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Zmiany w regulaminie wymagają formy pisemnej.")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("W sprawach nieuregulowanych niniejszym regulaminem mają zastosowanie zapisy statutu oraz obowiązujące przepisy prawa.")
            }
        }
    }
}
